import styled from 'styled-components';

export const Container = styled.div <{ backgroundColor?: string; backgroundImage?: string }> `
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  background-image: ${({backgroundImage}) => `url(${backgroundImage})`};
  background-repeat: none repeat;
  background-size: cover;
  background-position: center; 
  overflow-x: hidden !important;

  @media screen and (max-width: 1060px){
    height: 100%;
    width: 100%;
  }
  
  @media screen and (max-height: 680px){
    height: 100%;

  }

  `;

export const WrapperForm = styled.div`
  display: flex;
  margin: 32px;
  
  @media screen and (max-width: 1060px){
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /* padding: 64px; */
    margin:32px 0;
    max-width:562px 
  }
  


  @media screen and (max-width: 680px){
    padding: 16px;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  padding: 64px;
  background-color: #ffffff;
  border-radius: 0px 8px 8px 0px;
 
  @media screen and (max-width: 1060px){
    border-radius: 0 0 8px 8px;
    width: 100%;
  }
  
  @media screen and (max-width: 720px){
    width: auto;
  }
`;

export const FormContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;

  @media screen and (max-width: 1060px){
    width: 100%;
  }
`;

export const Cards = styled.div`

`

export const LeftSide = styled.section <{ backgroundColor?: string }> `
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 32px;
    background-color: ${({ backgroundColor }) => backgroundColor};
    border-radius: 8px 0px 0px 8px;
    max-width: 462px;
    width: 100%;

    @media screen and (max-width: 1060px){
      border-radius: 8px 8px 0 0;
      padding: 32px 64px;
      max-width: 100%;
    }

    @media screen and (max-width: 720px){
    width: auto;
    }
    
    /* @media screen and (max-width: 680px){
      border-radius: 8px 8px 0 0;
      padding: 32px;
      max-width: 88%;
    }
    @media screen and (max-width: 570px){
      border-radius: 8px 8px 0 0;
      padding: 32px;
      max-width: 86%;
    } */
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 32px;

  @media screen and (max-width: 680px){
    flex-direction: column;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 24px;
`;

export const DescriptionText = styled.p<{ textcolor?: string }>`
   align-self: stretch;
  font-family: "Inter", Helvetica;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  letter-spacing: 0;
  line-height: 24px;
  color: ${props => props.textcolor};

  @media screen and (max-width: 680px){
    font-size: 14px;
    line-height: 18px;
  }
`;

export const Description = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

export const ScheduleCard = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 16px;
    width: 100%;
    margin: 16px 16px;
`;

export const Title = styled.span<{ color?: string, letterSpacing?: string }>`
  font-family: "Inter-Tight", Helvetica;
  font-weight: 700;
  font-size: 32px;
  letter-spacing: ${props => props.letterSpacing ? props.letterSpacing : '0px'};
  text-align: start;
  line-height: 40px;
  color: ${props => props.color};

  @media screen and (max-width: 680px){
    font-size: 24px;
    line-height: 32px;
  }
`;

export const InfoText = styled.p`
  align-self: stretch;
  color: #000000;
  text-align: center;
  font-family: "InterTight-Regular", Helvetica;
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0.2px;
  line-height: 14px;
  font-style: normal;
`;

export const DateTag = styled.div<{ tagColor?: string }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    position: relative;
    background-color: ${({ tagColor }) => tagColor};
    border-radius: 8px;
    color: white;
    text-align: center;
    white-space: nowrap;
    font-family: "InterTight-Bold", Helvetica;
    font-weight: 700;
    font-size: 16px;
    letter-spacing: 0.5px;
    line-height: 20px;
    font-style: normal;

    @media screen and (max-width: 680px){
      font-size: 14px;
    }
`;

export const DateRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  
  >p {
    color: white;
    font-family: "InterTight-SemiBold", Helvetica;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.5px;
    line-height: 16px;
    font-style: normal;
    margin: 0;

    @media screen and (max-width: 680px){
      font-size: 12px;
      line-height: 16px;
    }
  }
`;